import './accept-modal.scss';

import { CustomModal } from '@/components/Shared/Modal/CustomModal';
import { Button, CircledImage } from '@/components/Shared/ui';

import type { IAdditionalConditions } from '../../types/intersecting.types';

interface AcceptedOfferInterface {
  id: string;
  extId: string;
  icon: string;
  name: string;
  monthlyPayment: string;
  rate?: number;
  loanAmount: string;
  initialPayment: string;
  loanPeriod?: string;
  auto: string;
  insuranceAmount?: string;
  additionalConditions?: IAdditionalConditions;
}

type TAcceptModalProps = {
  selectedOffer: AcceptedOfferInterface | null;
  showAcceptModal: boolean;
  onSelectBankOffer: () => void;
  onCancel: () => void;
  isAcceptLoading: boolean;
};

const AcceptModal = ({
  showAcceptModal,
  onCancel,
  selectedOffer,
  onSelectBankOffer,
  isAcceptLoading
}: TAcceptModalProps) => {
  return (
    <CustomModal
      isModalOpen={showAcceptModal}
      title="Предложение выбрано"
      handleCancel={onCancel}
      handleOk={onSelectBankOffer}
      editClass="accept-offer-modal"
      footer={[
        <Button key="back" onClick={onCancel}>
          Отмена
        </Button>,
        <Button
          isLoading={isAcceptLoading}
          key="submit"
          variant="filled-red"
          onClick={onSelectBankOffer}
        >
          Подтвердить
        </Button>
      ]}
    >
      <div>
        <p className="accept-offer-modal__text">
          Нажимая “Подтвердить” клиент соглашается с условиями Банка
        </p>

        <div className="accept-offer-modal__header">
          <CircledImage
            src={selectedOffer?.icon || ''}
            alt={selectedOffer?.name || ''}
            size={40}
          />
          <div>
            <h6 className="accept-offer-modal__chosen-text">Выбран банк</h6>
            <h5 className="accept-offer-modal__bank">
              {selectedOffer?.name || ''}
            </h5>
          </div>
        </div>

        <div className="accept-offer-modal__main-info">
          <div>
            <p className="accept-offer-modal__main-label">Ежемесячный платеж</p>
            <p className="accept-offer-modal__main-value">
              {selectedOffer?.monthlyPayment || ''} ₸
            </p>
          </div>
          <div>
            <p className="accept-offer-modal__main-label">Ставка</p>
            <p className="accept-offer-modal__main-value accept-offer-modal__main-value--red">
              {selectedOffer?.rate || ''} %
            </p>
          </div>
        </div>

        {selectedOffer?.additionalConditions?.monthlyPayment && (
          <div className="accept-offer-modal__main-info">
            <div>
              <p className="accept-offer-modal__main-label">
                Платеж в мес. после льготного периода
              </p>
              <p className="accept-offer-modal__main-value">
                {selectedOffer?.additionalConditions?.monthlyPayment || ''} ₸
              </p>
            </div>
            <div>
              <p className="accept-offer-modal__main-label">Ставка</p>
              <p className="accept-offer-modal__main-value accept-offer-modal__main-value--red">
                {selectedOffer?.additionalConditions?.rate || ''} %
              </p>
            </div>
          </div>
        )}

        <div className="accept-offer-modal__sub-info">
          <div className="accept-offer-modal__sub-item">
            <p className="accept-offer-modal__sub-label">Сумма займа</p>
            <p className="accept-offer-modal__sub-value">
              {selectedOffer?.loanAmount || ''} ₸
            </p>
          </div>
          <div className="accept-offer-modal__sub-item">
            <p className="accept-offer-modal__sub-label">
              Первоначальный взнос
            </p>
            <p className="accept-offer-modal__sub-value">
              {selectedOffer?.initialPayment || ''} ₸
            </p>
          </div>
          <div className="accept-offer-modal__sub-item">
            <p className="accept-offer-modal__sub-label">Срок</p>
            <p className="accept-offer-modal__sub-value">
              {selectedOffer?.loanPeriod || ''} месяца
            </p>
          </div>
          {selectedOffer?.additionalConditions?.loanPeriod && (
            <div className="accept-offer-modal__sub-item">
              <p className="accept-offer-modal__sub-label">
                Срок после льготного периода
              </p>
              <p className="accept-offer-modal__sub-value">
                {selectedOffer?.additionalConditions?.loanPeriod || ''} месяца
              </p>
            </div>
          )}
          <div className="accept-offer-modal__sub-item">
            <p className="accept-offer-modal__sub-label">Продукт</p>
            <p className="accept-offer-modal__sub-value">
              {selectedOffer?.auto || ''}
            </p>
          </div>
          {selectedOffer && selectedOffer.insuranceAmount ? (
            <div className="accept-offer-modal__sub-item">
              <p className="accept-offer-modal__sub-label">
                Дополнительные услуги
              </p>
              <p className="accept-offer-modal__sub-value">
                КАСКО{' '}
                {selectedOffer && selectedOffer.insuranceAmount
                  ? selectedOffer.insuranceAmount
                  : '5000'}{' '}
                ₸
              </p>
            </div>
          ) : null}
        </div>
      </div>
    </CustomModal>
  );
};

export default AcceptModal;
